export enum ELEMENT_TYPES {
  "IFRAME" = "IFRAME",
  "TEXT" = "TEXT",
  "LINK" = "LINK",
  "SCREENSHARE" = "SCREENSHARE",
  "IMAGE" = "IMAGE",
}


export enum PLAN_TYPE {
  FREE = 'FREE',
  BOOSTED = 'BOOSTED',
  BASIC = 'BASIC',
  PRO = 'PRO',
  STUDIO = 'STUDIO',
  TRIAL_V1 = 'TRIAL_V1',
}

export enum SLIDE_TEMPLATES {
  "START_PAGE" = "START_PAGE",
  "TEXT_IMAGE" = "TEXT_IMAGE",
  "IMAGE_2TEXT" = "IMAGE_2TEXT",
  "PLAIN_TEXT" = "PLAIN_TEXT",
}

export enum OBJECT_FIT {
  "CONTAIN" = "CONTAIN",
  "COVER" = "COVER",
}

export enum TEXT_ALIGN {
  "START" = "START",
  "CENTER" = "CENTER",
  "END" = "END",
}

export enum ROLE {
  "ADMIN" = "ADMIN",
  "COLLABORATOR" = "COLLABORATOR",
  "GUEST" = "GUEST",
}

export enum CONNECTION_STATUS {
  "NORMAL" = "NORMAL",
  "ERROR" = "ERROR",
  "RECONNECTING" = "RECONNECTING",
}

export interface Image {
  cdnUrl: string;
  height: string | number;
  width: string | number;
}

export enum PLOT_MODE {
  "VIEW_ALL" = "VIEW_ALL",
  "NO_ACCESS" = "NO_ACCESS",
}

export enum PLOT_THEME {
  "BLACK" = "BLACK",
  "LIGHT" = "LIGHT",
  "BLUE" = "BLUE",
  "YELLOW" = "YELLOW",
}

export interface Pos {
  x: number;
  y: number;
}

export interface Size {
  w: number;
  h: number;
}

export interface ElementBase {
  id: string;
  type: ELEMENT_TYPES;
  pos: Pos;
  size: Size;
}

export type Position = {
  x: number;
  y: number;
};

export interface TextElementData {
  content: string;
  align: TEXT_ALIGN;
  timestamp: number;
}

export interface TextElement extends ElementBase {
  data: TextElementData;
}

export interface ImageElementData {
  cdnUrl: string;
  objectFit: OBJECT_FIT;
  background: string;
  height: string | number;
  width: string | number;
}

export interface ImageElement extends ElementBase {
  data: ImageElementData;
}

export interface IframeElementData {
  url: string;
}

export interface IframeElement extends ElementBase {
  data: IframeElementData;
}

export interface ParticipantCursor {
  pos: Pos;
  identityId: string;
}

export type RoomElement = IframeElement | ImageElement | TextElement;

export interface Room {
  roomId: string;
  component: string;
  name: string;
  capacity: number;
  elements: RoomElement[];
}

export interface ElementUpdate {
  id: string;
  pos?: Pos;
  size?: Size;
  data?: ImageElementData | TextElementData | IframeElementData;
}

export const getLoraOptons = (id: string | undefined) => {
  // const tiguanLoraUsers = (
  //   id === 'user_jKO4RFY8WyAV72jLWFg7g'
  //   || id === 'user_2ZbQImK6PHN0frn8ZlgIW'
  //   || id === 'user_vKpNcEB-RDH-QZH6bArzv'
  //   || id === 'user_gbiIir1nLvbrfkiNI_pYo'
  // )
  // const volvoLoraUsers = (
  //   id === 'user_k_McJZ0_LViQXlqY4S0pi'
  // )

  // const rrUsers = (
  //   id === 'user_0i70SP3kEydAww20vpiuc'
  // )
  const secretModeEnabled = id === 'user_ncW1SxIG5X3mwQGtmPp5Z' || id === 'user_ztvePOlS8Ylq0N0c5wFhK' || id === 'user_RzgcIMD1nu3VgXxx1ohCx' || id === 'user_bwxZh45ttxCf6U3MQeJCc'
  const genesisMode = id === 'user_s3aVjccTKxcnUYslz2-gB'

  // const audiThMode = id === 'user_GFlUPjOFZH7yzZZCnkP2-' || id === 'user_i4v9e-_x7c6houFvhfi10'

  const ravMode = id === 'user_qahcavTEExbZY-TtoSddx' || id === 'user_jVMWLWkLVwH8xGdTRXby9' || id === 'user_hnoyZAeojfB2fFVysq_ER'


  if (secretModeEnabled) {
    return [
      // { value: '', label: 'None' },
      { value: 'mag_eqs', label: 'Mercedes EQS (Demo car)' },
      { value: 'mag_bmw', label: 'Mag Bmw X3M' },
      { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
      // { value: 'u_atlas', label: 'VW Atlas' },
      { value: 'u_bmw', label: 'BMW M5' },
      { value: 'mag_volvo', label: 'Volvo' },
      { value: 'r_rr', label: 'Range Rover' },
      { value: 'm_s5', label: 'Audi S5' },
      // { value: 'mag_gen_v2', label: 'Genesis v3' },
      // { value: 'mag_gen', label: 'Genesis Latest' },
      // { value: 'mag_gen_v4', label: 'Genesis (Experimental)' },
      { value: 'mag_gen_v5', label: 'Genesis' },
      { value: 'mag_rv4_v1', label: 'Toyota RAV4' },
      { value: 'mag_rv4_v2', label: 'Toyota RAV4 2' },
      // { value: 'mag_rv4_un', label: 'Toyota UN_RAV4' },
      { value: 'mag_audi_r8_rs', label: 'Audi R8 RS' },
      { value: 'mag_mercedes_g63', label: 'Mercedes G63 (Demo car)' },
      { value: 'mag_lexus_rx', label: 'Lexus RX' },
      { value: 'mag_lexus_rz', label: 'Lexus RZ' },
      { value: 'mag_lexus_es', label: 'Lexus ES' },
      { value: 'mag_lexus_lm', label: 'Lexus LM' },
      { value: 'mag_etron_2025', label: 'Audi E-tron 2025' },
      { value: 'mag_q5_2025', label: 'Audi Q5 2025' },
      // { value: 'mag_panamera', label: 'Porsche Panamera (Demo car)' },
      
      // { value: 'mag_gen_v3', label: 'Genesis V3' },
    ]
  }  
  
  if (genesisMode) {
    return [
      // { value: '', label: 'None' },
      // { value: 'mag_eqs', label: 'Mercedes EQS (Demo car)' },
      // { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
      { value: 'mag_audi_r8_rs', label: 'Audi R8 RS' },
      { value: 'mag_mercedes_g63', label: 'Mercedes G63 (Demo car)' },
      // { value: 'mag_panamera', label: 'Porsche Panamera (Demo car)' },
      { value: 'mag_gen_v5', label: 'Genesis' },
      // { value: 'mag_gen', label: 'Genesis Latest' },
    ]
  }

  // if (tiguanLoraUsers) {
  //   return [
  //     // { value: '', label: 'None' },
  //     // { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
  //     { value: 'mag_mercedes_g63', label: 'Mercedes G63 (Demo car)' },
  //     { value: 'mag_audi_r8_rs', label: 'Audi R8 RS (Demo car)' },
  //     // { value: 'u_atlas', label: 'VW Atlas (Demo car)' },
  //   ]
  // } 

  // if (volvoLoraUsers) {
  //   return [
  //     // { value: '', label: 'None' },
  //     // { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
  //     { value: 'mag_mercedes_g63', label: 'Mercedes G63 (Demo car)' },
  //     { value: 'mag_audi_r8_rs', label: 'Audi R8 RS (Demo car)' },
  //   ]
  // }

  // if (rrUsers) {
  //   return [
  //     // { value: '', label: 'None' },
  //     // { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
  //     { value: 'mag_mercedes_g63', label: 'Mercedes G63 (Demo car)' },
  //     { value: 'mag_audi_r8_rs', label: 'Audi R8 RS (Demo car)' },
  //   ]
  // }

  // if (audiThMode) {
  //   return [
  //     // { value: '', label: 'None' },
  //     { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
  //     // { value: 'm_s5', label: 'Audi S5' }
  //   ]
  // }

  if (ravMode) {
    return [
      // { value: '', label: 'None' },
      // { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
      { value: 'mag_mercedes_g63', label: 'Mercedes G63 (Demo car)' },
      { value: 'mag_audi_r8_rs', label: 'Audi R8 RS (Demo car)' },
      // { value: 'mag_panamera', label: 'Porsche Panamera (Demo car)' },
      { value: 'mag_rv4_v1', label: 'Toyota RAV4' },
      { value: 'mag_rv4_v2', label: 'Toyota RAV4 (August 2025)' },
      { value: 'mag_lexus_rx', label: 'Lexus RX' },
      { value: 'mag_lexus_rz', label: 'Lexus RZ' },
      { value: 'mag_lexus_es', label: 'Lexus ES' },
      { value: 'mag_lexus_lm', label: 'Lexus LM' },
    ]
  }

  return [
    // { value: '', label: 'None' },
    // { value: 'u_tiguan', label: 'VW Tiguan (Demo car)' },
    { value: 'mag_mercedes_g63', label: 'Mercedes G63 (Demo car)' },
    { value: 'mag_audi_r8_rs', label: 'Audi R8 RS (Demo car)' },
    // { value: 'mag_panamera', label: 'Porsche Panamera (Demo car)' },
  ]
}

// Speech Recognition API TypeScript declarations
declare global {
  interface Window {
    SpeechRecognition: typeof SpeechRecognition;
    webkitSpeechRecognition: typeof SpeechRecognition;
    Intercom?: (action: string, options?: any) => void;
    EncTracking?: {
      identify: (data: any) => void;
    };
  }
}

interface SpeechRecognition extends EventTarget {
  continuous: boolean;
  grammars: SpeechGrammarList;
  interimResults: boolean;
  lang: string;
  maxAlternatives: number;
  onaudioend: ((this: SpeechRecognition, ev: Event) => any) | null;
  onaudiostart: ((this: SpeechRecognition, ev: Event) => any) | null;
  onend: ((this: SpeechRecognition, ev: Event) => any) | null;
  onerror: ((this: SpeechRecognition, ev: SpeechRecognitionErrorEvent) => any) | null;
  onnomatch: ((this: SpeechRecognition, ev: SpeechRecognitionEvent) => any) | null;
  onresult: ((this: SpeechRecognition, ev: SpeechRecognitionEvent) => any) | null;
  onspeechend: ((this: SpeechRecognition, ev: Event) => any) | null;
  onspeechstart: ((this: SpeechRecognition, ev: Event) => any) | null;
  onstart: ((this: SpeechRecognition, ev: Event) => any) | null;
  serviceURI: string;
  start(): void;
  stop(): void;
  abort(): void;
}

interface SpeechRecognitionEvent extends Event {
  readonly resultIndex: number;
  readonly results: SpeechRecognitionResultList;
  readonly interpretation: any;
  readonly emma: Document;
}

interface SpeechRecognitionErrorEvent extends Event {
  readonly error: string;
  readonly message: string;
}

interface SpeechRecognitionResultList {
  readonly length: number;
  item(index: number): SpeechRecognitionResult;
  [index: number]: SpeechRecognitionResult;
}

interface SpeechRecognitionResult {
  readonly length: number;
  readonly isFinal: boolean;
  item(index: number): SpeechRecognitionAlternative;
  [index: number]: SpeechRecognitionAlternative;
}

interface SpeechRecognitionAlternative {
  readonly transcript: string;
  readonly confidence: number;
}

interface SpeechGrammarList {
  readonly length: number;
  item(index: number): SpeechGrammar;
  [index: number]: SpeechGrammar;
  addFromURI(src: string, weight?: number): void;
  addFromString(string: string, weight?: number): void;
}

interface SpeechGrammar {
  src: string;
  weight: number;
}

// declare var SpeechRecognition: {
//   prototype: SpeechRecognition;
//   new(): SpeechRecognition;
// };

// declare var webkitSpeechRecognition: {
//   prototype: SpeechRecognition;
//   new(): SpeechRecognition;
// };